import { render, staticRenderFns } from "./NavigationProfile.vue?vue&type=template&id=68ae5d33&scoped=true"
import script from "./NavigationProfile.vue?vue&type=script&lang=js"
export * from "./NavigationProfile.vue?vue&type=script&lang=js"
import style0 from "./NavigationProfile.vue?vue&type=style&index=0&id=68ae5d33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae5d33",
  null
  
)

export default component.exports